// Libs
import * as React from 'react';
import { useTranslation } from '@external/react-i18next';

// Components
import { Icon } from '@components/Icon';
import { Button } from '@components/Button';

interface Props {
  toggleMenuClick: () => void;
  toggleRef: React.RefObject<HTMLButtonElement>;
  optionsButton?: boolean;
  titleText?: string;
  customToggleButton?: React.ReactElement;
}

export const ToggleButton: React.FC<Props> = ({
  toggleMenuClick,
  toggleRef,
  optionsButton = false,
  titleText = '',
  customToggleButton = null,
}) => {
  const { t } = useTranslation();
  if (customToggleButton) {
    return (
      <span
        onClick={toggleMenuClick}
        aria-haspopup="true"
        aria-expanded="false"
        ref={toggleRef}
      >
        {customToggleButton}
      </span>
    );
  }

  return optionsButton ? (
    <Button
      full
      small
      className="block context-menu-toggle mt-4"
      clickHandler={toggleMenuClick}
      aria-haspopup="true"
      aria-expanded="false"
      buttonRef={toggleRef}
      dataTestId="options-button"
    >
      {t('context-menu.options', 'options').toUpperCase()}
    </Button>
  ) : (
    <button
      type="button"
      className="block context-menu-toggle"
      data-testid="dots-button"
      aria-haspopup="true"
      aria-expanded="false"
      onClick={toggleMenuClick}
      ref={toggleRef}
    >
      <span aria-hidden="true">
        <Icon name="ui/overflow" />
      </span>
      <span className="hidden">
        {t('context-menu.open', 'Open context menu for {{titleText}}', {
          titleText,
        })}
      </span>
    </button>
  );
};
